import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes for prop type checking
import { Avatar, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import useStaticResources from "../../hooks/useStaticResources";
// useStaticResources hook for managing prefixes and handling certain matching patterns


// TickerAvatars component for displaying a row of avatars
const Avatars = ({ urls, alt, size = 48, shape='circle'}) => {
  const modifiedUrls = useStaticResources(urls);

  return (
    <Avatar.Group shape={shape}>
      {modifiedUrls.map((url, index) => (
        <Tooltip key={index} title={alt[index] || ''}>
          <Avatar
            src={url}
            size={size}
            icon={!url ? <UserOutlined /> : null}
            style={{ border: '1px solid rgba(0, 0, 0, 0.3)' }}
            shape={shape}
          />
        </Tooltip>
      ))}
    </Avatar.Group>
  );
};

Avatars.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.string).isRequired,
  alt: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.number,
  prefixMap: PropTypes.object,
};

Avatars.defaultProps = {
  alt: [],
  size: 32,
  prefixMap: {},
};

export default React.memo(Avatars);
